import React from "react";

import { Card, Icon } from "semantic-ui-react";
import useTheme from "../../../../hooks/useTheme";
import { AppColumn, AppRow } from "../../../UI/Layouts";
import { SizedBox } from "../../../UI/Sizes";
import AppText from "../../../UI/Texts/AppTexts";
import { useSelector } from "react-redux";
import { getLocale } from "../../../../utils/helperFunctions";
import { t } from "i18next";


export function JobInformationSection({ jobData }) {
    const theme = useTheme();
    const coreConstants = useSelector((state) => state.core.constants);
    const systemKnowledgeOptions = coreConstants.systemKnowledgeOptions ?? [];
    const workingHoursOptions = coreConstants.workingHours ?? [];

    const systems = (jobData?.systemKnowledge?.systems ?? []).map((id) => {
        const option = systemKnowledgeOptions.find((e) => e.id === id)?.text ?? id;
        return option;
    })

    const timeOfDay = (jobData?.timeOfDay ?? []).map((id) => {
        return (
            workingHoursOptions.find((e) => e.id === id)?.text[getLocale()] ?? id
        );
    });

    const allWorkfields = coreConstants.workfields ?? [];

    const workfields = (jobData?.workFields ?? [])?.map((wf) => {

        const appWorkfield = allWorkfields.find((e) => e.id === wf);
        const text = appWorkfield?.text[getLocale()] ?? wf;
        return {
            text: text,
            icon: appWorkfield?.icon,
        };
    });

    const source = jobData?.source

    const showMinimumExperience = ['bemlo', 'medlo'].includes(source);
    const showWaitingPeriod = ['bemlo', 'medlo'].includes(source);


    return (<AppColumn crossAxisAlignment={'start'}>
        <Card style={{
            width: '100%',
            borderRadius: theme.radius.default,
            padding: theme.spacing.elementPadding,
        }}>
            <AppText.Footnote use={"h2"} margins={{
                marginBottom: "0px",
                marginTop: "0px"
            }} fontWeight={600} color={theme.primaryColor}>{t('requirements')}</AppText.Footnote>
            <SizedBox height={theme.spacing.elementPadding} />
            <AppRow
                crossAxisAlignment={'center'}
                gap={theme.spacing.elementPaddingSmall}
                style={{ marginBottom: theme.spacing.elementPaddingSmall }}>
                <Icon color={theme.colors.grey} name="suitcase" style={{
                    fontSize: '18px',
                }} />
                <AppText.FootnoteSmall use={'h3'} margins={{ marginBottom: "0px", marginTop: "0px" }}>
                    {workfields.length > 0 ? workfields.map((e) => e.text).join(" , ") : t('jobdetail.specialization.not_required')}
                </AppText.FootnoteSmall>
            </AppRow>
            <AppRow
                crossAxisAlignment={'center'}
                gap={theme.spacing.elementPaddingSmall}
                style={{ marginBottom: (jobData?.timeOfDay || jobData?.onCallDuty) && theme.spacing.elementPaddingSmall }}>
                <Icon color={theme.colors.grey} name="user md" style={{
                    fontSize: '18px',
                }} />
                <AppText.FootnoteSmall use={'h3'} margins={{ marginBottom: "0px", marginTop: "0px" }}
                >
                    {systems.length > 0 ? systems.join(" , ") : t('jobdetail.no_system_requirement')}
                </AppText.FootnoteSmall>
            </AppRow>
            {(jobData?.timeOfDay && jobData?.timeOfDay?.length > 0) && <AppRow
                gap={theme.spacing.elementPaddingSmall}
                crossAxisAlignment={'center'}
                style={{ marginBottom: theme.spacing.elementPaddingSmall }}
            >
                <Icon name="clock" style={{
                    fontSize: '18px',
                }} />
                <AppText.FootnoteSmall use={'h3'}
                    margins={{
                        marginBottom: "0px",
                        marginTop: "0px"
                    }}
                >
                    {timeOfDay.join(" , ")}
                </AppText.FootnoteSmall>
            </AppRow>}

            <AppRow
                gap={theme.spacing.elementPaddingSmall}
                crossAxisAlignment={'center'}>
                <Icon color={theme.colors.grey} name="ambulance" style={{
                    fontSize: '15.8px',
                    paddingLeft: '2px',
                    marginRight: '6px',
                }} />
                <AppText.FootnoteSmall use={'h3'}
                    margins={{ marginBottom: "0px", marginTop: "0px" }}
                >
                    {jobData?.onCallDuty ? t('jobdetail.oncall_duty') : t('jobdetail.no_oncall_duty')}
                </AppText.FootnoteSmall>
            </AppRow>

            {showMinimumExperience && <AppColumn>
                <SizedBox height={theme.spacing.elementPaddingSmall} />
                <AppRow
                    gap={theme.spacing.elementPaddingSmall}
                    crossAxisAlignment={'center'}>
                    <Icon color={theme.colors.grey}
                        name="check circle"
                        style={{
                            fontSize: '18px',
                            paddingLeft: '2px',
                            marginRight: '6px',
                        }} />
                    <AppText.FootnoteSmall use={'h3'}
                        margins={{ marginBottom: "0px", marginTop: "0px" }}
                    >
                        {t('minimum_year_experience_on_similar_role')}
                    </AppText.FootnoteSmall>
                </AppRow>
            </AppColumn>}

            {showWaitingPeriod && <AppColumn>
                <SizedBox height={theme.spacing.elementPaddingSmall} />
                <AppRow
                    gap={theme.spacing.elementPaddingSmall}
                    crossAxisAlignment={'center'}>
                    <Icon color={theme.colors.grey}
                        name="hourglass half"
                        style={{
                            fontSize: '18px',
                            paddingLeft: '2px',
                            marginRight: '6px',
                        }} />
                    <AppText.FootnoteSmall use={'h3'}
                        margins={{ marginBottom: "0px", marginTop: "0px" }}
                    >
                        {t('waiting_period_in_this_region')}
                    </AppText.FootnoteSmall>
                </AppRow>
            </AppColumn>}


        </Card>
        <SizedBox height={theme.spacing.contentElementPadding} />
    </AppColumn>)
}
